export default "__VITE_ASSET__BbpnWymC__"